/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ApiCreateOrUpdateDraftApprovalPolicyRequest,
  ApiPolicySwitchRequest,
  ApiSpendPolicyRequest,
  ApprovalPoliciesResponse,
  ApprovalPolicyDto,
  GetPoliciesParams,
  PsaEnabledResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiSpendPolicyControllerV2<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-spend-policy-controller-v-2
   * @name UpdateOrCreateDraft
   * @request PUT:/api/v2/spend-policy/draft
   */
  updateOrCreateDraft = (
    data: ApiCreateOrUpdateDraftApprovalPolicyRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ApprovalPolicyDto, any>({
      path: `/v2/spend-policy/draft`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateOrCreateDraftPath = '/v2/spend-policy/draft'
  static updateOrCreateDraftMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-spend-policy-controller-v-2
   * @name SwitchTov2
   * @request POST:/api/v2/spend-policy/switch-to-v2
   */
  switchTov = (data: ApiPolicySwitchRequest, params: RequestParams = {}) =>
    this.http.request<ApprovalPolicyDto, any>({
      path: `/v2/spend-policy/switch-to-v2`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static switchTovPath = '/v2/spend-policy/switch-to-v2'
  static switchTovMethod = 'POST'
  /**
   * No description
   *
   * @tags api-spend-policy-controller-v-2
   * @name GenerateFromV1
   * @request POST:/api/v2/spend-policy/generate-from-v1
   */
  generateFromV1 = (params: RequestParams = {}) =>
    this.http.request<ApprovalPolicyDto, any>({
      path: `/v2/spend-policy/generate-from-v1`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static generateFromV1Path = '/v2/spend-policy/generate-from-v1'
  static generateFromV1Method = 'POST'
  /**
   * No description
   *
   * @tags api-spend-policy-controller-v-2
   * @name PublishDraftPolicy
   * @request POST:/api/v2/spend-policy/draft/publish
   */
  publishDraftPolicy = (data: ApiSpendPolicyRequest, params: RequestParams = {}) =>
    this.http.request<ApprovalPolicyDto, any>({
      path: `/v2/spend-policy/draft/publish`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static publishDraftPolicyPath = '/v2/spend-policy/draft/publish'
  static publishDraftPolicyMethod = 'POST'
  /**
   * No description
   *
   * @tags api-spend-policy-controller-v-2
   * @name DeleteDraftPolicy
   * @request POST:/api/v2/spend-policy/draft/delete
   */
  deleteDraftPolicy = (data: ApiSpendPolicyRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v2/spend-policy/draft/delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static deleteDraftPolicyPath = '/v2/spend-policy/draft/delete'
  static deleteDraftPolicyMethod = 'POST'
  /**
   * No description
   *
   * @tags api-spend-policy-controller-v-2
   * @name GetPolicies
   * @request GET:/api/v2/spend-policy
   */
  getPolicies = (query: GetPoliciesParams, params: RequestParams = {}) =>
    this.http.request<ApprovalPoliciesResponse, any>({
      path: `/v2/spend-policy`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getPoliciesPath = '/v2/spend-policy'
  static getPoliciesMethod = 'GET'
  /**
   * No description
   *
   * @tags api-spend-policy-controller-v-2
   * @name GetPolicyById
   * @request GET:/api/v2/spend-policy/policies/{id}
   */
  getPolicyById = (id: string, params: RequestParams = {}) =>
    this.http.request<ApprovalPolicyDto, any>({
      path: `/v2/spend-policy/policies/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPolicyByIdPath = '/v2/spend-policy/policies/${id}'
  static getPolicyByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-spend-policy-controller-v-2
   * @name IsPostSpendApprovalEffectivelyEnabled
   * @request GET:/api/v2/spend-policy/is-psa-effectively-enabled
   */
  isPostSpendApprovalEffectivelyEnabled = (params: RequestParams = {}) =>
    this.http.request<PsaEnabledResponse, any>({
      path: `/v2/spend-policy/is-psa-effectively-enabled`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static isPostSpendApprovalEffectivelyEnabledPath = '/v2/spend-policy/is-psa-effectively-enabled'
  static isPostSpendApprovalEffectivelyEnabledMethod = 'GET'
}
